// web-staking-estimator-frontend/src/components/common/StepBadge.js
import React from "react";

/**
 * Badge component displaying a step number in the UI workflow
 */
export function StepBadge({ n }) {
  return (
    <span className="step-badge" aria-hidden="true">
      {n}
    </span>
  );
}
